import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "asp-order box-flex-column" }

import AverageOrderList from '../components/average-order-list.vue';
import ContinuousOrderList from '../components/continuous-order-list.vue';
import { ref } from 'vue';
import { BaseTabs, BaseTabPane, BaseLayoutFlexContent } from 'xrk-components';
import { useRoute, useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'tax-withholding',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const pageType = ref('2');

const setPageType = () => {
  if (route.query.orderNo) {
    // 清除路由上的查询参数
    router.replace({
      query: { force: Date.now() }
    });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseTabs), {
      onClick: setPageType,
      modelValue: pageType.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pageType).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(BaseTabPane), {
          label: "一般劳务",
          name: "2"
        }),
        _createVNode(_unref(BaseTabPane), {
          label: "连续劳务",
          name: "3"
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_unref(BaseLayoutFlexContent), null, {
      default: _withCtx(() => [
        (pageType.value === '2')
          ? (_openBlock(), _createBlock(AverageOrderList, {
              key: 0,
              style: {"height":"100%"}
            }))
          : _createCommentVNode("", true),
        (pageType.value === '3')
          ? (_openBlock(), _createBlock(ContinuousOrderList, {
              key: 1,
              style: {"height":"100%"}
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})